import { IClient, IClientSearch } from "@interfaces";
import axiosClient from "./axiosClient";

interface IUpdateReferredByParams {
  referredBy: string,
  clientId: string
}

interface IUpdateDeliverySiteParams {
  deliverySite: string,
  clientId: string
}

export const clientApi = {
  clients: (params: IClientSearch) => {
    const url = "/client/get";
    return axiosClient.get(url, { params });
  },
  cdicClients: (params: IClientSearch) => {
    const url = "/client/cdic-get";
    return axiosClient.get(url, { params });
  },
  client: (id: string) => {
    const url = `/client/get/${id}`;
    return axiosClient.get(url);
  },
  cdicClient: (id: string) => {
    const url = `/client/cdic-get/${id}`;
    return axiosClient.get(url);
  },
  clientPhone: (phone: string) => {
    const url = `/client/get-client-by-phone/${phone}`;
    return axiosClient.get(url);
  },
  create: (params: IClient) => {
    const url = `/client/create`;
    return axiosClient.post(url, params);
  },
  update: (params: IClient, id: string) => {
    const url = `/client/update/${id}`;
    return axiosClient.put(url, params);
  },

  updateReferredBy: (params: IUpdateReferredByParams) => {
    const url = `/client/update-referredBy`;
    return axiosClient.post(url, params);
  },

  updateDeliverySite: (params: IUpdateDeliverySiteParams) => {
    const url = `/client/update-delivery-site`;
    return axiosClient.post(url, params);
  },

  export: (params: IClientSearch) => {
    const url = `/client/export-records`;
    return axiosClient.post(url, params );
  },

  exportCdic: (params: IClientSearch) => {
    const url = `/client/export-cdic-records`;
    return axiosClient.post(url, params );
  },

};
